import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';
export const ConsultantRoute = ({ children }) => {
  const userSignin = useSelector((state) => state.userSignin);
  const { userInfo } = userSignin;
  return userInfo && (userInfo.isAdmin || userInfo.isConsultant) ? children : <Navigate to="/" />;
};